export enum OriginEnum {
    policyDetail = 1,
    briefcaseList = 2,
    renewalsList = 3,
    adminLeads = 4,
    rejectionList = 5,
    policyChange = 6,
    commissions = 7
}